// extracted by mini-css-extract-plugin
export default {"root":"_36f_J","content":"_2xDIh","head":"_3lODg"};